<template>
  <b-container fluid class="no-bottom">
    <b-row>
      <b-col class="d-flex">
        <backlink class="mt-20" />
        <div class="flex-grow-1">
          <h1>
            Scanner une référence
          </h1>
        </div>
      </b-col>
    </b-row>
    <div class="bottom-actions scan-bar">
      <!-- QR-004 : dépannage quand l'étiquette est illisible. La douchette reste le
           mode nominal, sélectionné par défaut. Même présentation qu'en préparation
           et au retour, pour que le geste soit le même d'un écran à l'autre. -->
      <ScanModeSwitch v-model="scanMode" class="scan-mode" />
      <!-- QR-006 : en mode photo, le viseur prend la place du champ. Il n'en occupe
           que la hauteur utile, pour laisser voir la liste, et masquer le champ évite
           de faire surgir le clavier du mobile sur un écran où l'on ne tape pas. -->
      <CameraScanner v-if="cameraEntry" @decoded="onCameraDecoded" @close="closeCameraScanner" />
      <b-button-group v-else>
        <input type="text" v-model="internal_code"
          :placeholder="manualEntry ? 'Saisir un code référence' : 'Scanner une référence unique ou un produit à la vente'"
          class="form-control" ref="internal_code" @keyup.enter="submitManualEntry()" />
        <b-button v-if="manualEntry" variant="outline-secondary" :disabled="!internal_code"
          @click="submitManualEntry()" style="border-left: 1px solid #e9e9e9">OK</b-button>
      </b-button-group>
    </div>
  </b-container>

</template>

<script>
import scannedValueMixin from "@/mixins/scannedValue";

export default {
  name: "ReferenceMobileScan",
  mixins: [scannedValueMixin],
  data() {
    return {
      internal_code: null
    };
  },
  mounted(){
    this.$store.dispatch("product/getAllForSelect");
    if (this.$refs.internal_code) {
      this.$refs.internal_code.focus();
    }
  },
  watch: {
    internal_code: function (internal_code) {
      // QR-004 : en saisie manuelle, la validation est explicite (bouton / Entrée).
      if (internal_code && !this.manualEntry) {
        // La douchette tape caractère par caractère : on attend la fin de la salve.
        this.handleScannedValueDebounced(internal_code);
      }
    },
  },
  methods: {
    // QR-003 : appelé par le mixin une fois la valeur normalisée.
    onScanResolved: function (code) {
      this.getReferenceOrProduct(code);
    },
    /**
     * Cherche une référence ou un produit à la vente à partir de son code barre
     * @param   {string|interger} internal_code  Code barre
     * @returns                             
     */
    getReferenceOrProduct: function (internal_code) {
      // On recherche un produit à la vente
      var product = this.$store.getters["product/getItemByInternalCode"](
        internal_code
      );
      if (product) {
        this.$router.push({
          name: "ProductMobileDetail",
          params: { id: product.id},
        });
      } else {
        // Si aucun produit n'a été trouvé, on recherche une référence
        this.$store
          .dispatch("reference/isAvailable", internal_code)
          .then((reference) => {
            if (reference) {
              this.$router.push({
                name: "ReferenceMobileDetail",
                params: { id: reference.id},
              });
            }
          })
          .catch((error) => {
            this.$toastr.error(
              "Le code barre scanné ne correspond à aucune référence ou produit à la vente"
            );
          });
      }

      this.internal_code = null;
    },
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

// Zone de scan / saisie manuelle : même barre que sur le retour mobile
// (BusinessReturnMobileDetail) et la préparation, d'où la classe `bottom-actions`
// conservée pour en hériter les styles. Cet écran n'a pas d'autre barre d'actions :
// elle reste dans le flux, sous le titre, plutôt que collée au bas de la fenêtre.
.bottom-actions.scan-bar {
  position: static;
  box-shadow: none;
  border: 1px solid #eeeeee;
  margin-bottom: 15px;
}

.scan-bar {
  .btn-group {
    width: 100%;
  }

  input {
    border-radius: 0;
    border: none;
    padding: 5px;
    margin: 20px 25px;
    @extend .clanprobook;
  }

  // Le champ de scan porte déjà la marge basse : le sélecteur de mode se cale
  // sur son retrait horizontal sans en rajouter.
  .scan-mode {
    margin: 20px 25px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReferenceMobile/ReferenceMobileScan.vue